export const setListTab = navItem => {
  let block = document.querySelector(`.tabs .${navItem.dataset.link}`);
  let container = navItem.closest('.container');
  document.querySelector('.listTabs-block nav li.active')?.classList.remove('active');
  navItem.parentNode.classList.add('active');
  container.querySelector('.tabs .active')?.classList.add('hide');
  setTimeout(() => {
    container.querySelector('.tabs .active')?.classList.remove('active', 'hide');
    block?.classList.add('active', 'hide');
    setTimeout(() => {
      block?.classList.add('show');
      setTimeout(() => {
        block?.classList.remove('hide', 'show');
      }, 400);
    }, 50);
  }, 400);
};

document.querySelectorAll('.listTabs-block nav li a').forEach(navItem => {
  navItem.addEventListener('click', e => {
    e.preventDefault();
    setListTab(navItem);
  });
});
